export const LOCATIONS: Record<string, string> = {
  rantzausgade: 'Borgerservice Rantzausgade',
  noerrebro_bibliotek: 'Nørrebro Bibliotek',
  bispebjerg_bibliotek: 'Bispebjerg Bibliotek',
};

